import React from 'react';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
// Ressources
import withGlobalStyles from '../../utils/global-styles';
import { paths } from '../paths';
import { clsx } from '../../utils/htmlUtils';

interface ReserverForbiddenProps extends WithTranslation {
    globalClasses: any;
}

const ReserverForbidden = (props: ReserverForbiddenProps): JSX.Element => {
    const classes = useStyles();
    const { t, globalClasses } = props;

    return (
        <div className={clsx(globalClasses.block, classes.reserverForbiddenContainer)}>
            <p>{t('forbidden')}</p>
            <Button
                startIcon={<Icon>back</Icon>}
                variant="contained"
                type="submit"
                className={clsx(globalClasses.roundButton, classes.button)}
                component={RouterLink}
                to={paths.reserver}
                color={'secondary'}
            >
                {t('common:back')}
            </Button>
        </div>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        reserverForbiddenContainer: { flex: 1, marginRight: 40 },
        button: { marginRight: 0, marginTop: 30 },
    }),
);

const ReserverForbiddenView = withGlobalStyles(withTranslation(['reserver', 'common'])(ReserverForbidden));
export default ReserverForbiddenView;
